<template>
  <div class="col-md-12 p-0 mx-auto" style="border: none!important;">
    <p v-if="ownAds.length>0" class="text-muted">توجه! :برای انتخاب آگهی موردنظر روی هر سطر کلیک کنید.</p>
    <div class="mx-auto col-md-12 text-center">
      <v-progress-circular
          indeterminate
          v-if="loading"
          :width="3"
          color="primary"
          class="mx-auto text-center"
      ></v-progress-circular>
      <p v-if="ownAds.length<=0">اطلاعاتی برای شما یافت نشد!</p>
    </div>

    <v-menu
        v-if="ownAds.length>0"
        top
        :close-on-click="true"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            color="primary"
            v-bind="attrs"
            v-on="on"
        >
          فیلترها
        </v-btn>
      </template>

      <v-list>
        <v-list-item
            v-for="(item, index) in selectList"
            :key="index"
            @click="filterSelections(item.value)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-data-table
        v-if="ownAds.length>0"
        v-model="selectedAds"
        :headers="headers"
        :items="ownAds"
        :item-key="ownAds.id"
        :search="search"
        :items-per-page="5"
        @click:row="rowClicked"
        align="center"
        :footer-props="{'items-per-page-text':'تعداد  ردیف  در هر صفحه', 'items-per-page-options':[5,10, 30, 50, 100, -1], }"
        class="elevation-1 table-bordered table-hover table-striped p-4">
      <template v-slot:top>
        <div class="row mx-auto">
          <v-btn class="my-auto purple lighten-4" @click="selectAll">انتخاب همه</v-btn>
          <v-text-field
              v-model="search"
              label="جستجو"
              append-icon="mdi-magnify"
              dense
              class="mx-4 my-3 mt-4"
          ></v-text-field>
        </div>
      </template>
      <template v-slot:item="{ item }">
        <tr data-item="advertise" :class="selectedAds.indexOf(item.id)> -1?'purple lighten-4':''"
            @click="rowClicked(item)">
          <td>{{ ownAds.indexOf(item) + 1 }}</td>
          <td>{{ item.advertise_title }}</td>
          <td>{{ item.phone + '  - ' + item.nickname }}</td>
        </tr>
      </template>

      <template v-slot:[`footer.page-text`]="items">
        {{ items.pageStart }} - {{ items.pageStop }} از {{ items.itemsLength }}
      </template>

    </v-data-table>
  </div>
</template>

<script>
import button from "@/view/pages/button";
import {dataTableProps} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import createTarefe from "@/view/pages/tarefe/createTarefe";
import CreateDefault from "@/view/pages/ads/default/createDefault";
import NumberSelector from "@/view/pages/ads/numberSelector";

export default {
  name: "ExpertAdsList",
  components: {NumberSelector, CreateDefault, TitleRibbon, button, dataTableProps, createTarefe},
  data() {
    return {
      search: '',
      loading: false,
      translates: [],
      selectList: [
        {title: 'انتخاب همه از بالا', value: 'top'},
        {title: 'انتخاب همه از پایین', value: 'bottom'},
        {title: 'انتخاب همه تصادفی', value: 'shuffle'},
      ],
      ownAds: {},
      selectedAds: [],
      headers: [
        {text: 'ردیف', value: 'id'},
        {text: 'عنوان', value: 'advertise_title'},
        {text: 'شماره', value: 'phone'},
      ],
      remainingData: [],
      CurrentTab: ''
    }
  },
  methods: {
    getRemainingData() {
      this.loading = true;
      $.ajax({
        url: `${url}/divar/service`,
        method: "GET",
        fn: this.getRemainingData,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token
        },
        success: (res) => {
          this.loading = false;
          this.remainingData = res.data;
          this.ownAds = res.data
        }
      })
    },
    rowClicked(row) {
      this.toggleSelection(row.id);
    },
    toggleSelection(keyID) {
      if (this.selectedAds.includes(keyID)) {
        this.selectedAds = this.selectedAds.filter(
            selectedKeyID => selectedKeyID !== keyID
        );
      } else {
        this.selectedAds.push(keyID);
      }
    },
    filterOnlyCapsText(value, search, item) {
      return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().indexOf(search) !== -1
    },
    selectAll() {
      this.selectedAds = [];

      $('[data-item]').each(function () {
        let rp = this;
        setTimeout(function () {
          rp.click()
        }, 150)
      });
    },
    filterSelections(position) {
      switch (position) {
        case 'top':
          this.selectAll();
          break;
        case 'bottom':
          if (this.selectedAds.length < this.ownAds.length)
            this.selectAll();
          this.selectedAds.reverse();
          break;
        case 'shuffle':
          this.selectAll()
          if (this.selectedAds.length < this.ownAds.length)
            setTimeout(() => {
              this.selectedAds.sort(() => Math.random() - 0.5);
            }, 2500)
      }
    }
  },
  watch: {
    selectedAds: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    },
  },
  mounted() {
    this.getRemainingData();
  }
}
</script>

<style>
table thead.v-data-table-header th {
  font-size: 15px !important;
  padding: 13px !important;
  text-align: right !important;
}

table thead.v-data-table th {
  font-size: 15px !important;
  padding: 13px !important;
  text-align: right !important;
}

#list-item-294-5 .v-list-item__content .v-list-item__title {
  display: none;
}

#list-item-294-5 .v-list-item__content:after {
  content: 'همه';
}
</style>